import axios from 'axios';

/**
 * Setup axios interceptors for authentication
 * - Attaches token to all requests
 * - Handles 401 responses and token refresh
 * - Redirects to login on auth failure
 */
export const setupAxiosInterceptors = (getToken, onLogout) => {
  // Request interceptor: Add token to headers
  axios.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor: Handle auth errors
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const status = error.response?.status;

      // Handle 401 Unauthorized
      if (status === 401) {
        console.warn('Unauthorized: Token invalid or expired');
        onLogout();
        // Redirect to login
        window.location.href = '/login';
        return Promise.reject(new Error('Session expired. Please login again.'));
      }

      // Handle 403 Forbidden
      if (status === 403) {
        console.warn('Forbidden: Access denied');
        window.location.href = '/dashboard';
        return Promise.reject(new Error('Access denied.'));
      }

      // Handle 500 errors
      if (status === 500) {
        console.error('Server error:', error.response?.data?.message);
      }

      return Promise.reject(error);
    }
  );
};
